import { useEffect, useState } from 'react';

const useUpdateKey = (keyDependency: string) => {
  const [customKey, setCustomKey] = useState(0);
  useEffect(() => {
    setCustomKey(Math.random());
  }, [keyDependency]);
  return customKey;
};

export default useUpdateKey;
